"use strict";

angular.module("licensure.services").factory("Process", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/Process", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
            GetApplicationProcesses: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/Process", {
                        params: {
                            ProcessTypeID: "0491A896-8D28-4C76-9716-FC466C985B7A",
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
